import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BaseCrudModalComponent } from 'projects/ProjetoBaseAngular/app/base-crud-modal.component';
import { TypesService } from 'projects/admin/src/domain/services';
import { DataTablesRequest, ModelSearch } from 'projects/ProjetoBaseAngular/domain/models';
import { OptionSearchType, SearchType } from 'projects/ProjetoBaseAngular/domain/types';
import { MetaMsgTemplateButtonModel, MetaMsgTemplateComponentModel } from '../../../../domain/models';
import { MetaMsgTemplateButtonType, MetaMsgTemplateComponentType } from '../../../../domain/types';
import { MetaMsgTemplateButtonService } from '../../../../domain/services/meta-msg-template-button.service';
import { MetaMsgTemplateComponentService } from '../../../../domain/services/meta-msg-template-component.service';

@Component({
  selector: 'app-meta-msg-template-button-modal',
  templateUrl: './msg-template-button-modal.component.html'
})
export class MetaMsgTemplateButtonModalComponent extends BaseCrudModalComponent<MetaMsgTemplateButtonModel> implements OnInit {
  @ViewChild('modal') modal: ModalDirective;
  @Input('metaMsgTemplateId') metaMsgTemplateId: string;

  constructor(
    injector: Injector,
    readonly service: MetaMsgTemplateButtonService,
    readonly componentService: MetaMsgTemplateComponentService,
    readonly typesService: TypesService
  ) {
    super(injector, service);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected initializeForm(model: MetaMsgTemplateButtonModel) {
    this.form = this.formBuilder.group({
      id: [model.id],
      dataInclusao: [model.dataInclusao, Validators.required],
      dataAlteracao: [model.dataAlteracao],
      registroAtivo: [model.registroAtivo],
      metaMsgTemplateComponentId: [model.metaMsgTemplateComponentId, Validators.required],
      tipo: [model.tipo, Validators.required],
      text: [model.text, [Validators.required, Validators.maxLength(100)]],
      url: [model.url, Validators.maxLength(500)],
      phoneNumber: [model.phoneNumber, Validators.maxLength(30)],
      order: [model.order]
    });
  }

  protected newModel(): MetaMsgTemplateButtonModel {
    const model = new MetaMsgTemplateButtonModel();
    model.id = this.commonService.newGuid();
    model.dataInclusao = new Date();
    model.registroAtivo = true;
    model.metaMsgTemplateComponentId = null;
    model.tipo = MetaMsgTemplateButtonType.QuickReply;
    model.text = "";
    model.url = "";
    model.phoneNumber = "";
    model.order = 1;

    return model;
  }

  async save(autoSave: boolean = false) {
    if (!this.form.value.metaMsgTemplateComponentId) {
      const metaMsgTemplateComponentId = await this.getButtonsComponentId();
      this.form.patchValue({ metaMsgTemplateComponentId });
    }

    super.save(autoSave);
  }

  private async getButtonsComponentId(): Promise<string> {
    const response = await this.componentService.getResponse({
      draw: 1,
      start: 0,
      length: 1,
      searches: [
        new ModelSearch('metaMsgTemplateId', OptionSearchType.Equals, SearchType.Guid, this.metaMsgTemplateId),
        new ModelSearch('tipo', OptionSearchType.Equals, SearchType.Int, MetaMsgTemplateComponentType.Buttons)
      ],
      selectColumns: [{ data: 'id' }]
    } as DataTablesRequest).toPromise();

    if (response.data && response.data.length > 0) {
      return response.data[0].id;
    }

    const component = new MetaMsgTemplateComponentModel();
    component.id = this.commonService.newGuid();
    component.dataInclusao = new Date();
    component.registroAtivo = true;
    component.metaMsgTemplateId = this.metaMsgTemplateId;
    component.tipo = MetaMsgTemplateComponentType.Buttons;
    component.format = null;
    component.text = "";
    component.exampleJson = "";
    component.order = 99;
    component.parametros = [];

    const created = await this.componentService.create(component).toPromise();
    return created.id;
  }
}
